<div class="flex-box" fillComponentParentView="fillComponentParentView">
  <div class="flex-heading">
    <div class="list-header col-xs-12"><span class="pr-3">Hero Ingredient  ({{heroIngredientsCount || 0}})</span>
      <div class="pull-right"><i class="fa fa-plus-square-o ml-2 pointer" routerLink="new"></i></div>
    </div>
  </div>
  <ag-grid-angular
            class="ag-theme-balham"
            style="height: 100%;"
            [columnDefs]="columnDefs"
            [components]="components"
            [rowBuffer]="0"
            [rowModelType]="ui.grid.rowModelType"
            [paginationPageSize]="ui.grid.pageSize"
            [cacheBlockSize]="ui.grid.pageSize"
            [cacheOverflowSize]="1"
            [maxConcurrentDatasourceRequests]="1"
            [infiniteInitialRowCount]="1"
            [maxBlocksInCache]="10"
            (gridReady)="onGridReady($event)">
          </ag-grid-angular>
</div>